(function () {
  function normalizeSelector(rawSelector) {
    if (!rawSelector) return '';
    var selector = rawSelector.trim();
    if (!selector) return '';
    if (selector.charAt(0) !== '#') {
      selector = '#' + selector;
    }
    return selector;
  }

  function parseBool(value) {
    return value === 'true' || value === true;
  }

  function findSectionBySelector(selector, fallbackContainer) {
    if (!selector) return null;
    var section = document.querySelector(selector);
    if (!section && fallbackContainer) {
      section = fallbackContainer.querySelector(selector);
    }
    return section;
  }

  function neutralizeInnerPageWidth(section) {
    if (!section) return;
    var pageWidthNodes = section.querySelectorAll('.page-width');
    pageWidthNodes.forEach(function (node) {
      node.classList.add('gc-section-joiner__inner-page-width');
    });
  }

  function setupJoiner(anchor) {
    if (!anchor || anchor.dataset.ready === 'true') return;

    var leftSelector = normalizeSelector(anchor.dataset.leftSelector);
    var rightSelector = normalizeSelector(anchor.dataset.rightSelector);
    if (!leftSelector || !rightSelector) return;

    var leftSection = findSectionBySelector(leftSelector);
    var rightSection = findSectionBySelector(rightSelector);
    if (!leftSection || !rightSection) return;
    if (leftSection === rightSection) return;

    var group = document.createElement('div');
    group.className = 'gc-section-joiner__group';
    if (parseBool(anchor.dataset.equalHeight)) {
      group.classList.add('gc-section-joiner__group--equal-height');
    }

    neutralizeInnerPageWidth(leftSection);
    neutralizeInnerPageWidth(rightSection);

    var usePageWidth = parseBool(anchor.dataset.usePageWidth);
    if (usePageWidth) {
      group.classList.add('gc-section-joiner__group--use-page-width');
    }

    var mobileGap = parseInt(anchor.dataset.gapMobile || '16', 10);
    var desktopGap = parseInt(anchor.dataset.gapDesktop || '24', 10);
    if (!Number.isNaN(mobileGap)) {
      group.style.setProperty('--gc-joiner-gap-mobile', mobileGap + 'px');
    }
    if (!Number.isNaN(desktopGap)) {
      group.style.setProperty('--gc-joiner-gap-desktop', desktopGap + 'px');
    }

    var mountNode = group;
    if (usePageWidth) {
      var pageWidthWrap = document.createElement('div');
      pageWidthWrap.className = 'page-width gc-section-joiner__page-width';
      pageWidthWrap.appendChild(group);
      mountNode = pageWidthWrap;
    }

    // Never nest .shopify-section inside another .shopify-section — the theme editor
    // treats that as broken HTML. Mount the grid wrapper as a sibling before this joiner.
    var joinerSectionRoot = anchor.closest('.shopify-section');
    if (joinerSectionRoot && joinerSectionRoot.parentNode) {
      joinerSectionRoot.parentNode.insertBefore(mountNode, joinerSectionRoot);
    } else {
      anchor.parentNode.insertBefore(mountNode, anchor);
    }
    group.appendChild(leftSection);
    group.appendChild(rightSection);
    anchor.dataset.ready = 'true';
  }

  function initAllJoiners(root) {
    var scope = root || document;
    var anchors = scope.querySelectorAll('.gc-section-joiner');
    anchors.forEach(setupJoiner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllJoiners(document);
    });
  } else {
    initAllJoiners(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllJoiners(event.target);
  });
})();
